import styled from 'styled-components';

import { LandingHero } from 'constants/landing-hero';

const MOBILE = '@media (max-width: 960px)';

export const Wrap = styled.div`
  width: 100%;
  padding: 8.8rem 7.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.4rem;

  ${MOBILE} {
    padding: 4.8rem 2.4rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 112rem;

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: ${LandingHero.neutral.cardBg};
  border: 0.1rem solid ${LandingHero.neutral.cardBorder};
  border-radius: 2.2rem;
  padding: 2.8rem 2.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  backdrop-filter: blur(1.2rem);
  -webkit-backdrop-filter: blur(1.2rem);
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), border-color 0.4s ease;

  &:hover {
    transform: translateY(-0.6rem);
    border-color: ${LandingHero.creator.cardBorder};
  }

  ${MOBILE} {
    padding: 2rem 1.8rem;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.4rem;
`;

export const Avatar = styled.div<{ $background: string }>`
  width: 5rem;
  height: 5rem;
  border-radius: 1.4rem;
  background: ${({ $background }) => $background};
  color: ${LandingHero.logoText};
  font-size: 1.6rem;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const Name = styled.div`
  font-size: 1.4rem;
  font-weight: 800;
  color: ${LandingHero.textPrimary};
`;

export const Date = styled.div`
  font-size: 1.2rem;
  color: ${LandingHero.textFaint};
`;

export const Description = styled.div`
  font-size: 1.4rem;
  line-height: 1.45;
  color: ${LandingHero.textMuted};
`;

export const TagRow = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
`;

export const Testimonial = styled.div`
  background: ${LandingHero.band.bg};
  border: 0.1rem solid ${LandingHero.band.border};
  border-radius: 2.2rem;
  padding: 2.8rem 3.2rem;
  max-width: 76rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  backdrop-filter: blur(1.2rem);
  -webkit-backdrop-filter: blur(1.2rem);

  ${MOBILE} {
    padding: 2rem 1.8rem;
  }
`;

export const Quote = styled.div`
  font-size: 1.5rem;
  line-height: 1.55;
  color: ${LandingHero.textBody};
`;

export const Attribution = styled.div`
  font-size: 1.1rem;
  color: ${LandingHero.textFaint};
`;
